import { render, staticRenderFns } from "./allTeams.vue?vue&type=template&id=5dcbdb02&scoped=true&"
import script from "./allTeams.vue?vue&type=script&lang=js&"
export * from "./allTeams.vue?vue&type=script&lang=js&"
import style0 from "./allTeams.vue?vue&type=style&index=0&id=5dcbdb02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbdb02",
  null
  
)

export default component.exports